import { jsx as r } from "@emotion/react/jsx-runtime";
import { FilterButton as n } from "./variant/FilterButton/FilterButton.js";
import { GroupButton as e } from "./variant/GroupButton/GroupButton.js";
import { PageButton as i } from "./variant/PageButton/PageButton.js";
import { SelectButton as u } from "./variant/SelectButton/SelectButton.js";
const l = (t) => {
  const {
    variant: o
  } = t;
  return o === "filters" ? /* @__PURE__ */ r(n, { ...t }) : o === "select" ? /* @__PURE__ */ r(u, { ...t }) : o === "group" ? /* @__PURE__ */ r(e, { ...t }) : /* @__PURE__ */ r(i, { ...t });
};
export {
  l as DynamicBusinessModalButton
};
